import React, { useContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  RouteProps,
  Redirect,
} from 'react-router-dom';

import { AuthContext } from '../context/AuthContext';
import routes from './config';
import Layout from '../containers/Layout';
import Login from '../containers/Login';
import LoginLink from '../containers/LoginLink';
import Register from '../containers/Register';

interface IRoute extends RouteProps {
  routes: RouteProps[];
}

const RouteWithSubRoutes = (route: IRoute) => {
  // return (
  //   <Route
  //     path={route.path}
  //     render={(props) => (
  //       // pass the sub-routes down to keep nesting
  //       <route.component {...props} routes={route.routes} />
  //     )}
  //   />
  // );
};

const Routes: React.FC = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);

  const ProtectedRoute = ({ component: Component, ...rest }: any) => (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated === true ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );

  return (
    <Switch>
      <Route path="/login/:accessToken" component={Login} />
      <Route path="/login" component={Login} />
      <Route path="/login-link" component={LoginLink} />
      <Route path="/register" component={Register} />
      <ProtectedRoute path="/" component={Layout} />
    </Switch>
  );
};

export { RouteWithSubRoutes, routes };
export default Routes;
